const tokenInitialState = {
    token: {
        loading: false,
        error: null,
        data: null
    },
};

export default tokenInitialState;